export const BUSINESS = {
  name: 'Premier Auto Care of La Habra',
  phone: '+16572084742',
  phoneFormatted: '(657) 208-4742',
  address: {
    street: '521 W Imperial Hwy',
    city: 'La Habra',
    state: 'CA',
    zip: '90631',
    full: '521 W Imperial Hwy, La Habra, CA 90631',
  },
  hours: {
    weekdays: 'Mon-Sat: Call for hours',
    saturday: 'Sat: Open (closes 4 PM)',
    sunday: 'Sun: Closed',
  },
  email: null,
  website: 'https://premierautocarelh.com',
  googleMapsUrl: 'https://maps.app.goo.gl/4E9iWtbXTWePoZyt9',
  yelpUrl: 'https://www.yelp.com/biz/all-tune-and-lube-la-habra',
  rating: '4.5',
  googleReviewCount: '360',
  yelpReviewCount: '152',
  reviewCount: '510',
  yearEstablished: 1995,
  tagline: "La Habra's One-Stop Total Car Care Center — Since 1995",
  owner: 'Hamzeh S.',
  languages: ['English', 'Spanish'],
  certifications: ['ASE Certified', 'AAA Approved', 'STAR Certified Smog Station'],
}
